// local
import Api from '.';

export function list() {
    return Api.get('/patient');
}

export function create(data) {
    return Api.post('/patient', data);
}

export function update(id, data) {
    return Api.put(`/patient/${id}`, data);
}

export function init(id, data) {
    return Api.put(`/patient/init/${id}`, data);
}

export function deinit(id, data) {
    return Api.put(`/patient/deinit/${id}`, data);
}

export function detail(id) {
    return Api.get(`/patient/${id}`);
}

export default { list, create, update, init, deinit, detail };
